export default {
  LARGE: 'lg',
  MEDIUM: 'md',
  SMALL: 'sm',
  X_SMALL: 'xs',
};
